<template>
  <div class="subscription-satisfaction flex-center-wrapper">
    <div class="subscription-satisfaction__iconbox flex-center-wrapper">
      <rt-picture src="/assets/app/class/icon-guarantee.svg" />
    </div>
    <div class="subscription-satisfaction__content">
      <h2 class="subscription-satisfaction__content-name">Satisfaction guaranteed.</h2>
      <p class="subscription-satisfaction__content-description">
        You can cancel at anytime with the 30-Day trial period.
      </p>
    </div>
  </div>
</template>

<script>
import RtPicture from "../../common/Picture.vue";

export default {
  components: {
    RtPicture,
  },
};
</script>

<style lang="scss" scoped>

@import "../../common/variables";

.subscription-satisfaction {
  &__iconbox {
    background: #fff;
    padding: 12px;
    border-radius: 10px;
    margin-right: 11px;
  }

  &__content {
    &-name {
      font-family: $title-font;
      text-align: left;
      font-weight: 700;
      font-size: 18px;
      color: $title-dark-grey;
    }
    &-description {
      margin-top: 5px;
      text-align: left;
      font-size: 16px;
      color: $title-grey;
    }
  }
}
</style>
